<template>
  <div style="width: 100%">
    <div
      style="
        position: absolute;
        width: 540px;
        height: 236px;
        top: 20px;
        left: 10px;
      "
    >
      <dv-border-box-11
        :title="name"
        :title-width="320"
        :color="['#47b332', '#116401']"
        backgroundColor="rgba(17,87,1,.5)"
      >
        <div style="padding: 15px 36px">
          <el-button
            type="warning"
            icon="el-icon-d-arrow-left"
            circle
            size="small"
            style="pointer-events: auto"
            @click="$router.push('/industry/112340121100000')"
          />
          <div
            style="
              font-size: 16px;
              color: #9cfcd9;
              line-height: 150%;
              padding: 20px 0 0 0;
            "
          >
            {{ desc }}
          </div>
        </div>
      </dv-border-box-11>
    </div>
  </div>
</template>

<script>
import map from './ControlMap.js'
export default {
  data() {
    return {
      name: null, //乡镇的名称
      desc: null, //乡镇的介绍
    }
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    map.start(this, this.$route.params.town)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
    map.destroy()
  },
  methods: {
    setName(val) {
      this.name = val
    },
    setDesc(val) {
      this.desc = val
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/product/Control.vue